import React from "react";
import { Grid } from "@material-ui/core";

const NoContent = (props) => {

  return (
    <Grid container direction="row"
      justifyContent="center"
      alignItems="center">
      <Grid item className={"f24_700_HelveticaNeue"}>
        There are no records to display
      </Grid>
    </Grid>
  );
};

export default NoContent;
